import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  Td,
  Table,
  Input,
  Thead,
  Tbody,
  Tr,
  Th,
  Select,
  Stack,
  useDisclosure,
  Center,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import {
  FaEllipsisV,
  FaPlus,
  FaSort,
  FaSortUp,
  FaSortDown,
} from "react-icons/fa"; // Import sort icons
import { BASE_URL } from "../../../Globalapi/Globalapi";

const ListClass = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isDrawerOpen,
    onOpen: onDrawerOpen,
    onClose: onDrawerClose,
  } = useDisclosure();
  const [sortDirection, setSortDirection] = useState("asc"); // State for sorting direction
  const [fetchEnabled, setFetchEnabled] = useState(true);

  const [classData, setClassData] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState(null); // State to store selected class ID
  const [isEditModalOpen, setIsEditModalOpen] = useState(false); // State for Edit Class Modal
  const [sortOption, setSortOption] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [division, setDivision] = useState(""); // State for division
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate(); // Initialize useNavigate
  const [searchCategory, setSearchCategory] = useState("class");

  useEffect(() => {
    fetchClassData();
  }, []);

  const fetchClassData = async () => {
    try {
      const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

      const response = await fetch(
        `${BASE_URL}/admin/class/list_all_class.php?school_id=${school_id}`
      );
      const data = await response.json();
      console.log("Fetched Data:", data);

      if (data && data.success && Array.isArray(data.data)) {
        // Extract division IDs from the data array
        const divisionIds = data.data.map((item) => item.division_id);
        console.log("Division IDs:", divisionIds);

        // Store division IDs in state
        setDivision(divisionIds);

        // Store the entire class data in state
        setClassData(data.data);
      }
    } catch (error) {
      console.error("Error fetching class data:", error);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchClassData(); // Fetch data every 2 seconds
    }, 2000);

    return () => clearInterval(intervalId); // Cleanup on component unmount
  }, []);

  // Handle the actions from the dropdown menu
  const handleMenuAction = async (action, classId) => {
    setSelectedClassId(classId);
    switch (action) {
      case "assignTeacher":
        if (classId) onDrawerOpen();
        break;
      case "editClass":
        if (classId) setIsEditModalOpen(true);
        break;
      case "removeTeacher":
        if (classId) {
          try {
            const response = await fetch(
              `${BASE_URL}/admin/class/remove_class_teacher.php`,
              {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ class_details_id: classId }),
              }
            );

            const result = await response.json();

            if (result.success) {
              console.log(result.message);
              fetchClassData(); // Refresh the class data after removal
            } else {
              console.error(result.message);
            }
          } catch (error) {
            console.error("Error removing class teacher:", error);
          }
        }
        break;
      case "deleteClass":
        if (classId) {
          try {
            // Delete class logic here if needed
            console.log(`Delete class ${classId}`);
          } catch (error) {
            console.error("Error deleting class:", error);
          }
        }
        break;
      default:
        break;
    }
  };

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
    // Implement sorting logic here if needed
  };

  const handleNavigate = (classId, division_id, id) => {
    localStorage.setItem("classId", classId);
    localStorage.setItem("class", id);

    localStorage.setItem("divisionId", division_id); // Use the passed division_id
    setDivision(division_id); // Set division state
    navigate(`/class/individual/class/${classId}`);
  };
  const handleSort = (key) => {
    const isSameKey = sortOption === key;
    const direction = isSameKey
      ? sortDirection === "asc"
        ? "desc"
        : "asc"
      : "asc";

    setSortDirection(direction);
    setSortOption(key);
    setFetchEnabled(false); // Disable auto-fetch when sorting

    const sortedData = [...classData].sort((a, b) => {
      if (key === "class") {
        // Define the strict order for 'class'
        const classOrder = [
          "Pre KG",
          "I",
          "II",
          "III",
          "IV",
          "V",
          "VI",
          "VII",
          "VIII",
          "IX",
          "X",
        ];

        // Sort based on the predefined order and direction
        const indexA = classOrder.indexOf(a[key]);
        const indexB = classOrder.indexOf(b[key]);

        // If sorting ascending, Pre KG should come first, otherwise X should come last
        return direction === "asc" ? indexA - indexB : indexB - indexA;
      } else if (key === "section") {
        // Handle section sorting (if applicable)
        const sectionOrder = ["KG", "LP", "UP", "HS"];
        return direction === "asc"
          ? sectionOrder.indexOf(a[key]) - sectionOrder.indexOf(b[key])
          : sectionOrder.indexOf(b[key]) - sectionOrder.indexOf(a[key]);
      } else {
        // Generic sorting for other columns
        return direction === "asc"
          ? a[key] > b[key]
            ? 1
            : -1
          : a[key] < b[key]
          ? 1
          : -1;
      }
    });

    setClassData(sortedData);
  };

  const getSortIcon = (key) => {
    if (sortOption !== key) return <FaSort />;
    return sortDirection === "asc" ? <FaSortUp /> : <FaSortDown />;
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleCategoryChange = (e) => {
    setSearchCategory(e.target.value);
  };
  const filteredClassData = classData.filter((classItem) => {
    if (searchCategory === "class") {
      return classItem.class.toLowerCase().includes(searchTerm.toLowerCase());
    }
    if (searchCategory === "division") {
      return classItem.division
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
    }
    if (searchCategory === "teacher") {
      return classItem.name?.toLowerCase().includes(searchTerm.toLowerCase());
    }
    return true; // No filter applied if no category selected (fallback)
  });
  return (
    <Box p={6} borderRadius="md" mx="auto" bg="white">
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        p={3}
        className="sb"
      >
        <Stack direction="row" spacing={4}>
          <Flex align="center">
            <Text mr={2}>Rows Per Page</Text>
            <Select
              width="100px"
              value={rowsPerPage}
              onChange={(e) => setRowsPerPage(Number(e.target.value))}
              borderColor="#E9EDF4"
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </Select>
          </Flex>
        </Stack>
        <Flex
          align="center"
          spacing={4}
          direction={{ base: "column", md: "row" }}
        >
          {/* Dropdown to select search category */}
          <Select
            mt={{ base: "2" }}
            value={searchCategory}
            onChange={handleCategoryChange}
            // marginRight={2}
            marginRight={{ base: 0, md: "5px" }} // 100% width on mobile, fixed width on larger screens
            width={{ base: "100%", md: "150px" }} // 100% width on mobile, fixed width on larger screens
          >
            <option value="class">Class</option>
            <option value="division">Division</option>
            <option value="teacher">Teacher</option>
          </Select>

          {/* Input field for the search term */}
          <Input
            mt={{ base: "2" }}
            placeholder={`Search by ${
              searchCategory.charAt(0).toUpperCase() + searchCategory.slice(1)
            }`}
            value={searchTerm}
            onChange={handleSearchChange}
            width={{ base: "100%", md: "200px" }} // 100% width on mobile, fixed width on larger screens
          />
        </Flex>
      </Flex>

      {/* Table displaying class data */}
      <div style={{ overflowX: "auto" }}>
        <Table
          sx={{
            "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
          }}
        >
          <Thead>
            <Tr>
              <Th onClick={() => handleSort("class")}>
                <Box textAlign="center">
                  <Flex justify="space-between" align="center">
                    Class
                    {getSortIcon("class")}
                  </Flex>
                </Box>
              </Th>
              <Th>
                <Box textAlign="center">Division</Box>
              </Th>
              <Th onClick={() => handleSort("section")}>
                <Box textAlign="center">
                  <Flex justify="space-between" align="center">
                    Section
                    {getSortIcon("section")}
                  </Flex>
                </Box>
              </Th>
              <Th>
                <Box textAlign="center">Assigned Teacher</Box>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredClassData.map((classItem) => (
              <Tr key={classItem.id}>
                <Td>
                  <Box textAlign="center">
                    <Button
                      variant="link"
                      onClick={
                        () =>
                          handleNavigate(
                            classItem.class_id,
                            classItem.division_id,
                            classItem.id
                          ) // Pass division_id
                      }
                    >
                      {classItem.class}
                    </Button>
                  </Box>
                </Td>
                <Td>
                  <Box textAlign="center">{classItem.division}</Box>
                </Td>
                <Td>
                  <Box textAlign="center"> {classItem.section}</Box>
                </Td>
                <Td>
                  <Box textAlign="center"> {classItem.name}</Box>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </div>
    </Box>
  );
};

export default ListClass;
